const animations = {
	init () {
		AOS.init({
			disable: 'mobile'
		})
	}
}

animations.init()